import { logOut, UserInfo } from '@store/slices/auth.slice'
import api from '@services/api.service'
import { AppDispatch } from '@store/store'
import axios from 'axios'

const authEndpoint = ''

export const login =
  (email: string, login_key: string) => async (): Promise<string> => {
    try {
      const response = await api.post(`${authEndpoint}/login/`, {
        email: email,
        login_key: login_key,
      })
      return response.data.viewer_token
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 400) {
        throw new Error(error?.response?.data?.message)
      } else {
        throw new Error('Došlo k nečekané chybě')
      }
    }
  }

export const getLoginToken = (email: string) => async () => {
  try {
    const response = await api.post(`${authEndpoint}/login-token-request/`, {
      email: email,
    })
    return response.data.message
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      throw new Error(error?.response?.data?.message)
    } else {
      throw new Error('Došlo k nečekané chybě')
    }
  }
}

export const logout = () => (dispatch: AppDispatch) => {
  dispatch(logOut())
  window.location.href = '/login'
}

export const getUserInfoFromToken = (token: string): UserInfo => {
  const decodedString = atob(token)
  const data = JSON.parse(decodedString)
  return data.user_info
}
